import { Box, Paper, Typography } from '@mui/material';
import { NearbyVesselsFormValues } from '../nearby-vessels-form/nearby-vessels-form-values';

interface NearbyVesselsFormSummaryProps {
  formValues: NearbyVesselsFormValues;
}

function NearbyVesselsFormSummary({
  formValues,
}: NearbyVesselsFormSummaryProps) {
  return (
    <Paper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '0.5rem',
        }}
      >
        <Typography variant="body2">
          <b>Centre:</b> {formValues.centrePoint.latitude}{' '}
          {formValues.centrePoint.longitude}
        </Typography>
        <Typography variant="body2">
          <b>Radius:</b> {formValues.radius} NM
        </Typography>
        <Typography variant="body2">
          <b>Time since last AIS ping:</b> {formValues.timeSinceLastAIS} hours
        </Typography>
      </Box>
    </Paper>
  );
}

export default NearbyVesselsFormSummary;
